import * as yup from 'yup'

export const schema = yup.object().shape({
  file: yup
    .mixed()
    .test('fileSize', 'File is more large than 125 MB', value => !value || value?.size <= 250000000)
    .label('File')
})
